import * as angular from "angular";

angular
  .module('app.permission')
  .run(permissionRun);

/* @ngInject */
function permissionRun($rootScope, $state, PermPermissionStrategies) {

  $rootScope.enableElement = PermPermissionStrategies.enableElement;
  $rootScope.disableElement = PermPermissionStrategies.disableElement;

  ///////////////////////

  // default redirect if access is denied
  function accessDenied() {
    $state.go('403');
  }

  // redirect all denied permissions to 401
  const deniedHandle = $rootScope.$on('$stateChangePermissionDenied', accessDenied);

  // remove watch on destroy
  $rootScope.$on('$destroy', function () {
    deniedHandle();
  });
}
